import { MagicConfigMixin, ModalSize, modalService, configQuery } from '@gig/magic-common';
import { Mixins, Component } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_JURISDICTION_QUERY } from '@gig/magic-messages';
import { notificationService } from '@gig/magic-messaging';
import { Jurisdiction } from '@gig/magic-jurisdictions';
import { getRealityCheckApi } from '../../services/reality-check.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const DEFAULT_INTERVAL = 36e5;
let RealityCheckPrompterComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.rcConfig = {
      required: false,
      interval: 0,
      duration: 0,
      message: ""
    };
    this.currentJurisdiction = null;
    this.modalOpen = false;
  }
  get interval() {
    return this.rcConfig.interval * 60 * 1e3 || DEFAULT_INTERVAL;
  }
  get dismissible() {
    return this.rcConfig.duration === 0;
  }
  get duration() {
    return this.dismissible ? this.interval : this.rcConfig.duration;
  }
  created() {
    return __async(this, null, function* () {
      this.currentJurisdiction = yield window.queryBus.query(USER_JURISDICTION_QUERY);
      configQuery("realityCheck", (realityCheck) => {
        var _a;
        if (realityCheck) {
          this.rcConfig = realityCheck == null ? void 0 : realityCheck[this.currentJurisdiction];
          if ((_a = this.rcConfig) == null ? void 0 : _a.required) {
            this.initRcService();
          }
        } else {
          this.rcConfig = {
            required: false,
            interval: 0,
            duration: 0,
            message: ""
          };
        }
      });
    });
  }
  destroyed() {
    var _a;
    (_a = this.rcService) == null ? void 0 : _a.destroy();
    this.rcService = null;
  }
  initRcService() {
    const user = magic.session.getUser();
    this.rcService = getRealityCheckApi(!!user, user == null ? void 0 : user.lastVisit, this.interval);
    if (this.currentJurisdiction === Jurisdiction.ONJN) {
      return this.ONJNInitRcService(this.rcService);
    } else if (this.currentJurisdiction === Jurisdiction.LOTBA) {
      return this.LOTBAInitRcService(this.rcService);
    }
  }
  ONJNInitRcService(rcService) {
    let intervalMultiplier = 1;
    const notifications = [];
    rcService.onRealityCheckInterval(() => {
      const intervalText = this.rcConfig.interval * intervalMultiplier;
      const message = this.$t(this.rcConfig.message, {
        sessionTime: intervalText
      });
      if (intervalMultiplier !== 1) {
        notificationService.close(notifications[0]);
        notifications.shift();
      }
      const notification = notificationService.show(message, {
        closeDelay: this.interval,
        dismissible: this.dismissible
      });
      notifications.push(notification);
      intervalMultiplier++;
    });
  }
  LOTBAInitRcService(rcService) {
    rcService.onRealityCheckInterval(() => {
      const lotbaModal = document.createElement("magic-lotba-reality-check-modal");
      if (this.modalOpen) {
        return;
      }
      const modalOptions = {
        onClose: () => {
          this.modalOpen = false;
        },
        size: ModalSize.BORDERLESS
      };
      const modal = modalService.open(null, lotbaModal, __spreadValues({
        dismissible: false
      }, modalOptions));
      this.modalOpen = true;
      lotbaModal.addEventListener("enable-close", () => {
        modalService.updateOptions(modal, __spreadValues({
          dismissible: true,
          dismissibleBackdrop: true
        }, modalOptions));
      });
    });
  }
  render() {
    return null;
  }
};
RealityCheckPrompterComponent = __decorateClass([
  Component({
    name: "reality-check-prompter"
  })
], RealityCheckPrompterComponent);

export default RealityCheckPrompterComponent;
